import { useState, useEffect, useContext, useRef } from "react";
import { SiteSettingContext, AutherContext, ToastContext } from "../Context";
import { setState, getState } from "../../Constant/LocalStorage";
import { getKbInfo, getMailBoxDetails, getAvailableFeatures } from "../../Service/SiteSettingServices";
import { getDomainDetails } from "../../Service/CustomDomainServices";
import { getUsersList } from "../../Service/UsersService";
import {
  brandForm,
  userListForm,
  sitePageForm,
  codeSnippetForm
} from "../../Forms/Forms";
import { DD_OPTIONS } from "../../Components/Dropdown/constants";
import { CHOICE_DATA, FEATURE_FLAG_INTERNAL_KB, NO_KB_EXISTS } from "../../Pages/GetStarted/constants";

export default function SiteSettingProvider(props) {
  const { admin, setRedirectToken, redirectToken, authToken } =
    useContext(AutherContext);

    const { setNoNet, setShowToast } = useContext(ToastContext);

  const [brandCounter, setBrandCounter] = useState(false);
  const [isKbDeleted , setIsKbDeleted] = useState(false);
  const [availableFeatures, setAvailableFeatures] = useState({});
  const [userCounter, setUserCounter] = useState(false);
  const [siteSetCounter, setSiteSetCounter] = useState(false);
  // Selecting external as default as per figma
  const [kbType, setKbType] = useState(CHOICE_DATA[0]?.ID);
  const kbRef = useRef(kbType);
  const [roleType, setRoleType] = useState(DD_OPTIONS[0]?.id);

  const [kbRefetch, setKbRefetch] = useState(false);
  const [siteSettingsData, setSiteSettingsData] = useState(
    getState("siteSettingsData") || false
  );
  const [customDomainDetails, setCustomDomainDetails] = useState(false);
  const [userList, setUserList] = useState(getState("userList") || []);

  const [brandFormData, setBrandFormData] = useState(
    getState("brandFormData") || false
  );
  const [userFormData, setUserFormData] = useState(
    getState("userFormData") || false
  );
  const [siteFormData, setSiteFormData] = useState(
    getState("siteFormData") || false
  );
  const [codeSnippetFormData, setCodeSnippetFormData] = useState(
    getState("codeSnippetFormData") || []
  );
  const [customDomainCounter, setCustomDomainCounter] = useState(false);
  const [mailboxCounter, setMailboxCounter] = useState(false);
  const [mailboxList, setMailboxList] = useState(false);
  const [brandActionValidation, setBrandActionValidation] = useState(false);
  const [userActionValidation, setUserActionValidation] = useState(false);
  const [siteActionSettingValidation, setsiteSettingActionValidation] =
    useState(false);

  const fetchAvailableFeatures = (token = authToken) => {
    getAvailableFeatures(token).then((response) => {
      const { data: { availableFeatures: availableFftr = {} } } = response?.data || {};
      setAvailableFeatures(availableFftr);
      const isInternalKbFeature = availableFftr?.[FEATURE_FLAG_INTERNAL_KB];
      if (!isInternalKbFeature) {
        setKbType(CHOICE_DATA[1]?.ID);
      }
    }).catch((rej) => {
      if (rej.message === "Network Error") {
        setNoNet(true);
      } else {
        setNoNet(false);
        setShowToast('Unable to fetch features for the account.')
      }
      console.error(rej);
    });
  };

  useEffect(() => {
    if (siteSettingsData) {
      if (kbRef.current !== kbType) {
        setBrandActionValidation(false);
      } else if (
        JSON.stringify(brandForm(siteSettingsData)) ===
        JSON.stringify(brandForm(brandFormData))
      ) {
        setBrandActionValidation(true);
      } else {
        setBrandActionValidation(false);
      }
    }
  }, [brandFormData, kbType]);

  useEffect(() => {
    if (userFormData) {
      const old = userFormData?.filter((item) => item.knowledgeBaseAssigned);
      if (old?.length > 0) {
        setUserActionValidation(false);
      } else {
        setUserActionValidation(true);
      }
    }
  }, [userFormData]);

  useEffect(() => {
    if (siteSettingsData) {
      if (
        JSON.stringify(siteSettingsData && sitePageForm(siteSettingsData)) ===
          JSON.stringify(siteFormData && sitePageForm(siteFormData)) &&
        JSON.stringify(
          siteSettingsData && codeSnippetForm(siteSettingsData?.codeSnippet)
        ) ===
          JSON.stringify(
            codeSnippetFormData && codeSnippetForm(codeSnippetFormData)
          )
      ) {
        setsiteSettingActionValidation(true);
      } else {
        setsiteSettingActionValidation(false);
      }
    }
  }, [siteFormData, codeSnippetFormData]);

  useEffect(() => {
    if (siteSettingsData) {
      if (brandCounter === "Update") {
        if (Object.keys(siteSettingsData).length > 0) {
          if (!siteSettingsData?.kbType) siteSettingsData.kbType = kbType;
          setBrandFormData(brandForm(siteSettingsData));
        } else {
          setBrandFormData(brandForm({ kbType }));
        }
        setBrandCounter("Updated");
      }
    }
  }, [siteSettingsData, brandCounter]);

  useEffect(() => {
    if (userList) {
      if (userCounter === "Update") {
        setUserFormData(userList && userListForm(userList));
        setUserCounter("Updated");
      }
    }
  }, [userList, userCounter]);

  useEffect(() => {
    if (siteSettingsData) {
      if (siteSetCounter === "Update") {
        setSiteFormData(siteSettingsData && sitePageForm(siteSettingsData));
        setCodeSnippetFormData(
          siteSettingsData?.codeSnippet?.length > 0
            ? codeSnippetForm(siteSettingsData?.codeSnippet)
            : []
        );
        setSiteSetCounter("Updated");
      }
    }
  }, [siteSettingsData, siteSetCounter]);

  const getKbConfig = () => {
    getKbInfo()
      .then((res) => {
        if (brandCounter === false) {
          setBrandCounter("Update");
        }
        if (siteSetCounter === false) {
          setSiteSetCounter("Update");
        }
        if (customDomainCounter === false) {
          setCustomDomainCounter("Update");
        }
        if (mailboxCounter === false) {
          setMailboxCounter("Update");
        }
         let data = res?.data?.KbConfigurations;
         window.aptrinsic("identify",
          {
            //User Fields
            "id": data.users[0].userId,
            // "accountId": { { hiver UG id of user } }
          },
          {
            //Account Fields
            "usergroupid": data.users[0].usergroupId,
            // "ugName": { {hiver user group name } },
            // "planId": { {hiver user group plan id } },
            // "Plan": { {hiver user group plan name } },
          });

        //let users = data?.users;

        // users = users.map((user) => {
        //   let url = user.avatarUrl;
        //   checkImage(
        //     url,
        //     function () {
        //       url = user.avatarUrl;
        //     },
        //     function () {
        //       url = Avatar;
        //     }
        //   );
        //   user.avatarUrl = url;
        //   return user;
        // });

        setSiteSettingsData(data);
        if (data?.isInternal) {
          setKbType(CHOICE_DATA[0]?.ID);
          kbRef.current = CHOICE_DATA[0]?.ID;
        } else {
          setKbType(CHOICE_DATA[1]?.ID);
          kbRef.current = CHOICE_DATA[1]?.ID;
        }
        setNoNet(false);
        setRedirectToken(true);
      })
      .catch((rej) => {
        if (rej.message === "Network Error") {
          setNoNet(true);
        } else {
          setNoNet(false);
        if (rej?.status === 404) {
          if (brandCounter === false) {
            setBrandCounter("Update");
          }
          if (rej?.data?.message?.includes(NO_KB_EXISTS)) {
            setIsKbDeleted(true);
          }
          if (userCounter === false) {
            setUserCounter("Update");
          }
          if (siteSetCounter === false) {
            setSiteSetCounter("Update");
          }
          setSiteSettingsData(true);
          setRedirectToken(true);
        } else {
          setSiteSettingsData(false);
          setRedirectToken(false);
        }
      }
      });
  };

  useEffect(() => {
    if (siteSettingsData) {
      getUsersList().then((res) => {
        setNoNet(false);
        if (userCounter === false) {
          setUserCounter("Update");
        }
        let users = res.data?.users;
        if (siteSettingsData?.isSiteSettingCompleted) {
          users = users?.filter(
            (item) =>
              item.role !== "ADMIN" && item.knowledgeBaseAssigned === false
          );
        }

        // users = users.map((user) => {
        //   let url = user.avatarUrl;
        //   checkImage(
        //     url,
        //     function () {
        //       url = user.avatarUrl;
        //     },
        //     function () {
        //       url = Avatar;
        //     }
        //   );
        //   user.avatarUrl = url;
        //   return user;
        // });

        setUserList(users);
        setUserFormData(users)
      }) .catch((rej) => {
            if (rej.message === "Network Error") {
              setNoNet(true);
            } else {
              setNoNet(false);
              setUserList([]);
              setUserFormData([])
              if (userCounter === false) {
                setUserCounter("Update");
              }
            }
          });
    }
  }, [siteSettingsData]);

  useEffect(() => {
    if (admin) {
      getKbConfig();
      authToken && !Object.keys(availableFeatures).length && fetchAvailableFeatures(authToken);
    } else {
      setSiteSettingsData(false);
    }
  }, [admin, redirectToken, kbRefetch, authToken]);

  useEffect(() => {
    if (siteSettingsData) {
      if (customDomainCounter === "Update") {
      getDomainDetails()
        .then((res) => {
          setCustomDomainDetails(res.data);
          if(res?.data && res.data?.isCdnConfiguredWithSsl){
            setState("customDomainDetails",res.data)
          }
          if (customDomainCounter === "Update") {
            setCustomDomainCounter("Updated");
          }
          setNoNet(false);
        })
        .catch((rej) => {
           if (rej.message === "Network Error") {
              setNoNet(true);
            } else {
              setNoNet(false);
              if (rej.status === 404) {
                setCustomDomainDetails(false);
                if (customDomainCounter === "Update") {
                  setCustomDomainCounter("Updated");
                }
              }
            }
        });
    }
  }
  }, [customDomainCounter]);

  // useEffect(() => {
  //   setState("siteSettingsData", siteSettingsData);
  // }, [siteSettingsData]);

  // useEffect(() => {
  //   setState("userList", userList);
  // }, [userList]);

  // useEffect(() => {
  //   setState("brandCounter", brandCounter);
  // }, [brandCounter]);

  // useEffect(() => {
  //   setState("userFormData", userFormData);
  // }, [userFormData]);

  // useEffect(() => {
  //   setState("siteFormData", siteFormData);
  // }, [siteFormData]);
  // useEffect(() => {
  //   setState("codeSnippetFormData", codeSnippetFormData);
  // }, [codeSnippetFormData]);

  useEffect(() => {
    if (siteSettingsData) {
      if (mailboxCounter === "Update") {
        getMailBoxDetails()
          .then((res) => {
            setNoNet(false);
            setMailboxList(res.data.mailboxes);
            if (mailboxCounter === "Update") {
              setMailboxCounter("Updated");
            }
          })
          .catch((rej) => {
            if (rej.message === "Network Error") {
              setNoNet(true);
            } else {
              setNoNet(false);
              if (rej.status === 404) {
                setMailboxList([]);
                if (mailboxCounter === "Update") {
                  setMailboxCounter("Updated");
                }
              }
            }
          });
      }
    }
  }, [mailboxCounter]);
  return (
    <SiteSettingContext.Provider
      value={{
        availableFeatures,
        siteSettingsData,
        mailboxList,
        customDomainDetails,
        setCustomDomainDetails,
        setCustomDomainCounter,
        kbType,
        setKbType,
        userList,
        userFormData,
        setUserFormData,
        userActionValidation,

        brandFormData,
        setBrandFormData,
        brandActionValidation,

        siteFormData,
        setSiteFormData,
        codeSnippetFormData,
        setCodeSnippetFormData,
        siteActionSettingValidation,

        setKbRefetch,
        kbRefetch,
        setUserList,
        setBrandCounter,
        setUserCounter,
        setSiteSetCounter,
        roleType,
        setRoleType,
        isKbDeleted
      }}
    >
      {props.children}
    </SiteSettingContext.Provider>
  );
}
